module.exports = __webpack_public_path__ + "img/index-12.39ca7810.png";